<template>
  <div class="sls-phone-input-container">
    <v-select
      v-model="selectedCountry"
      :items="countries"
      class="sls-country-select"
      dense
      :label="$t('common.countryCode')"
      outlined
      @change="emitCombinedValue"
    />
    <v-text-field
      v-model="phoneNumber"
      v-bind="$attrs"
      class="sls-phone-input"
      dense
      :label="$t('common.phone')"
      outlined
      type="tel"
      @keydown.enter="$emit('enter', $event)"
      @input="emitCombinedValue"
    />
  </div>
</template>

<script>
export default {
  name: 'PhoneNumberInput',
  props: {
    value: {
      default: '+1',
      type: String,
    },
  },
  data() {
    const countries = [
      // Canada/USA
      { text: '+1', value: '+1' },
      // United Kingdom
      { text: '+44', value: '+44' },
      // Mexico
      { text: '+52', value: '+52' },
      // Australia
      { text: '+61', value: '+61' },
      // New Zealand
      { text: '+64', value: '+64' },
    ]

    const parsed = this.parsePhoneValue(this.value, countries)

    return {
      countries,
      phoneNumber: parsed.phoneNumber,
      selectedCountry: parsed.selectedCountry,
    }
  },
  methods: {
    parsePhoneValue(value, countries) {
      if (!value || !value.startsWith('+')) {
        return { selectedCountry: '+1', phoneNumber: value || '' }
      }

      const codes = countries
        .map((c) => c.value)
        .sort((a, b) => b.length - a.length)

      for (const code of codes) {
        if (value.startsWith(code) && value.length > code.length) {
          return {
            selectedCountry: code,
            phoneNumber: value.slice(code.length),
          }
        }
      }

      return { selectedCountry: '+1', phoneNumber: '' }
    },
    emitCombinedValue() {
      const combinedNumber = `${this.selectedCountry}${this.phoneNumber.replace(
        /\D/g,
        '',
      )}`
      this.$emit('input', combinedNumber)
    },
  },
}
</script>

<style lang="sass">
.sls-phone-input-container
  display: flex
  gap: 0
  margin: 0
  .sls-phone-input
    border-bottom-left-radius: 0
    border-top-left-radius: 0
    fieldset
      border-left: 0
      height: 45px
    &.error--text fieldset,
    &.v-input--is-focused fieldset
      border-left: 2px solid currentColor
  .sls-country-select
    border-bottom-right-radius: 0
    border-top-right-radius: 0
    max-width: 100px
    width: 25%
.theme--dark
  .sls-phone-input,
  .sls-country-select
    .v-input__control
      .v-input__slot
        background-color: $darkBackground !important
        fieldset
          border-color: $darkBorder !important
      input,
      .v-select__selection
        color: $white !important
</style>
